import styled, { keyframes } from 'styled-components';
import { COLORS } from '~/src/styles/tokens/colors';
import { rem } from '~/src/helpers/rem-converter.helper';
import { techAbilityPlankStyles } from '../tech-ability-plank.styles';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`;

export const TechAbilityPlank = styled.span`
    ${techAbilityPlankStyles};
    border-radius: ${BORDER_RADIUS.bigger12};
    padding: ${rem(8)} ${rem(12)};
    background-color: ${COLORS.constantLightestBlackberry};
`;

export const Content = styled.span`
    display: inline-flex;
    flex-direction: row;
    gap: ${rem(8)};
    align-items: center;
    flex-wrap: nowrap;
`;

export const TextPlank = styled.span`
    display: flex;
    ${FONTS.compact.regular.size14};
    line-height: ${rem(20)};
`;

export const SpinnerWrapper = styled.span`
    display: inline-flex;
    animation: ${spin} 1s linear infinite;
`;

export const IconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
`;
